import { createAction, props } from '@ngrx/store';

import { ErrorResponse } from '#types/core';
import { Filters, Sorts } from '#types/grid';
import { ListOfValuesResponse, MultipleListOfValuesResponse } from '#types/list';
import { SupplierLookupResponseBody } from '#types/shipment';

//
// shipment / request lists
//

export const RequestLists = createAction('[Shipment] - Request Lists');

//
// shipment lists
//

export const RequestShipmentLists = createAction('[Shipment.List] - Request Shipment Lists');
export const RequestShipmentListsSuccess = createAction(
  '[Shipment.List] - Request Shipment Lists Success',
  props<{ lists: MultipleListOfValuesResponse }>()
);
export const RequestShipmentListsFailure = createAction(
  '[Shipment.List] - Request Shipment Lists Failure',
  props<{ error: ErrorResponse }>()
);

//
// supplier / lookup dialog
//

export const SupplierLookupDialogRequestData = createAction('[Supplier.Lookup.Dialog] - Grid Request Data', props<{ id: string }>());
export const SupplierLookupDialogRequestDataWithParameters = createAction(
  '[Supplier.Lookup.Dialog] - Grid Request Data With Parameters',
  props<{ id: string; filters: Filters; page: number; first: number; rows: number; sorts: Sorts }>()
);
export const SupplierLookupDialogRequestDataWithFilters = createAction(
  '[Supplier.Lookup.Dialog] - Grid Request Data With Filters',
  props<{ id: string; filters: Filters }>()
);
export const SupplierLookupDialogRequestDataSuccess = createAction(
  '[Supplier.Lookup.Dialog] - Grid Request Data Success',
  props<{ id: string; data: SupplierLookupResponseBody }>()
);
export const SupplierLookupDialogRequestDataFailure = createAction(
  '[Supplier.Lookup.Dialog] - Grid Request Data Failure',
  props<{ id: string }>()
);

//
// barcode printer list
//

export const RequestBarcodePrinterList = createAction('[Shipment.List] - Request Barcode Printer List', props<{ facility: string }>());
export const RequestBarcodePrinterListSuccess = createAction(
  '[Shipment.List] - Request Barcode Printer List Success',
  props<{ facility: string; list: ListOfValuesResponse }>()
);
export const RequestBarcodePrinterListFailure = createAction(
  '[Shipment.List] - Request Barcode Printer List Failure',
  props<{ error: ErrorResponse }>()
);

//
// laser printer list
//

export const RequestLaserPrinterList = createAction('[Shipment.List] - Request Laser Printer List', props<{ facility: string }>());
export const RequestLaserPrinterListSuccess = createAction(
  '[Shipment.List] - Request Laser Printer List Success',
  props<{ facility: string; list: ListOfValuesResponse }>()
);
export const RequestLaserPrinterListFailure = createAction(
  '[Shipment.List] - Request Laser Printer List Failure',
  props<{ error: ErrorResponse }>()
);
